<template>

  <v-toolbar-items>

    <v-btn color="secondary" active-class="accent--text" x-small text :ripple="false"
           :to="{ path: '/wizard' }">
      Service Wizard
    </v-btn>

    <v-btn color="secondary" active-class="accent--text" x-small text :ripple="false"
           :to="{ name: 'provider-detail' }">
      Providers
    </v-btn>

    <v-btn color="secondary" active-class="accent--text" x-small text :ripple="false"
           :to="{ name: 'service-areas' }">
      Service Areas
    </v-btn>

    <v-btn color="secondary" active-class="accent--text" x-small text :ripple="false"
           :to="{ name: 'search-for-service' }">
      Find Service
    </v-btn>

    <v-btn color="secondary" active-class="accent--text" x-small text :ripple="false"
           :to="{ name: 'partners' }">
      Partners
    </v-btn>

  </v-toolbar-items>
</template>

<script>
export default {
  name: 'Navbar',
};
</script>
